import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { FirebaseMessagingService } from './generics/services/firebase-messaging.service';
import { AppService } from './global/services/app.service';

@Component({
  selector: 'app-my-app',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, OnDestroy {

  private _router: Subscription;
  loadingRouteConfig: boolean;
  constructor(
    
    private router: Router, 
    translate: TranslateService, 
    private fcmService: FirebaseMessagingService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
  }

  ngOnDestroy(): void {
    this._router?.unsubscribe();
  }

  ngOnInit() {
    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => { 
      const body = document.getElementsByTagName('body')[0];
      // Show message notificacion after of login
      var pathname = window.location.pathname;
      if((pathname != '/login' && pathname != '/forgot-password') && (Notification.permission == 'default' && this.fcmService.permissionStatus == false)){
          //this.fcmService.requestNotificationDialog();
      }
      const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
      if (body.classList.contains('modal-open')) {
        body.classList.remove('modal-open');
        modalBackdrop.remove();
      }
    });

    
    // Show loading components on LazyLoading
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });
  }
}
